import React from 'react'
import './Style.css'
import { AbstructVar } from '../general/general-component/abstruct-component/AbstructVar';
import { VariableProjectType } from './VariableProjectType';
import { filterProjectTypes } from '../../store/Actions/ActionProjectType';

function FilterProjectType({ translate }) {
    const { dispatch,langLocal } = AbstructVar()
    const { state, setStateCustom, setLoad } = VariableProjectType();
    const Filter = (e) => {
        e.preventDefault()
        dispatch(filterProjectTypes(state.name, setLoad))
    }
    return (
        <div className='filteruser shadow_main margin_main' dir={langLocal=== 'ar' ? "rtl" : "ltr"} >
            <h3>{translate('search_filter')}</h3>
            <div className='div_filter' >
                <input className={`input_filter ${langLocal === 'ar'? "margin_left_25": "margin_right_25"} `} placeholder={translate('name')} onChange={(e) => setStateCustom('name', e.target.value)} />
                <button className='btn_filter' onClick={Filter} >
                    {
                        state.Load ? "Loading ..." : `${translate('filter')}`
                    }
                </button>
            </div>
        </div>
    )
}

export default FilterProjectType